import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createSector } from "../../actions/sectorActions";

import classnames from "classnames";

class NewSector extends Component {
  constructor() {
    super();
    this.state = {
      sectorName: "",
      sectorCode: "",
      errors: {}
    };
    this.saveSector = this.saveSector.bind(this);
    this.cancel = this.cancel.bind(this);
  }


  //life cycle hooks
  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  onChange = e => this.setState({ [e.target.name]: e.target.value });


  saveSector = e => {
    e.preventDefault();
    let sector = {
      sectorName: this.state.sectorName,
      sectorCode: this.state.sectorCode,
      tradeUnion: {}

    };

    this.props.createSector(sector, this.props.history);

  };

  cancel() {
    this.props.history.push("/sector-list");
  }

  render() {
    const { errors } = this.state;

    return (
      <div className="container">

        <div className="card m-auto  border-primary shadow-lg rounded p-3">
          <h5 className="display-4 text-center">New Sector Type</h5>
          <p className="lead text-center">New Sector Details</p>
          <hr />
          {errors.message && <div className="alert alert-danger text-center" role="alert">
            {errors.message}
          </div>}
          <form onSubmit={this.saveSector}>
            <div className="row">
              <div className="form-group col-sm-6">
                <label >Sector Name</label>
                <input
                  className={classnames("form-control",
                    { "is-invalid": errors.sectorName })}
                  type="text"
                  name="sectorName"
                  id="sectorName"
                  value={this.state.sectorName}
                  onChange={this.onChange}
                  placeholder="Sector Name"

                />
                {errors.sectorName && (
                  <div className="invalid-feedback">
                    {errors.sectorName}
                  </div>
                )}
              </div>

              <div className="form-group col-sm-6">
                <label >Sector Code</label>
                <input
                  className={classnames("form-control",
                    { "is-invalid": errors.sectorCode })}
                  type="text"
                  name="sectorCode"
                  id="sectorCode"
                  value={this.state.sectorCode}
                  onChange={this.onChange}
                  placeholder="Sector Code"

                />
                {errors.sectorCode && (
                  <div className="invalid-feedback">
                    {errors.sectorCode}
                  </div>
                )}
              </div>


            </div>
            <div className="row">
              <div className="form-group col-sm-6">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mt-4"

                >Save</button>
              </div>
              <div className="form-group col-sm-6">
                <button
                  type="button"
                  className="btn btn-secondary btn-block mt-4"
                  onClick={this.cancel}
                >Cancel</button>
              </div>
            </div>
          </form>
        </div>

      </div>
    );
  }
}

NewSector.propTypes = {
  createSector: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { createSector }
)(NewSector);
